import AXIOS_INSTANCE from './axiosInstance'

export type PreventiveCareItem = {
  kind: 'immunisation' | 'growth' | (string & {})
  label: string
  status: string
  due_on: string | null
}

export type PreventiveCareResponse = {
  items: PreventiveCareItem[]
  counts: Record<string, number>
}

/** GET /api/patients/:id/preventive_care — what is due now (immunisations + growth check). */
export const fetchPreventiveCare = async (patientId: string): Promise<PreventiveCareResponse> => {
  const { data } = await AXIOS_INSTANCE.get<PreventiveCareResponse>(`patients/${patientId}/preventive_care`)
  return {
    counts: data?.counts ?? {},
    items: Array.isArray(data?.items) ? data.items : []
  }
}
